import { IUsuario } from '@/@types/Comunidade';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { FaSquarePhone } from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
import { getFotoUrl } from '@/lib/utils';

interface IDocente extends IUsuario { }

interface IDocenteItemProps {
    data: IDocente
}

const DocenteItem = ({ data }: IDocenteItemProps) => {

    const splitEmail = (email: string) => {
        return email.replace(/\./g, '. ').replace(/@/g, ' @');
    }

    return (
        <div className='flex gap-4 mt-4 items-center border-b-[1px] pb-3 font-normal'>
            <div>
                <Avatar className='w-[120px] h-[120px]'>
                    <AvatarImage src={getFotoUrl(data.foto)} />
                    <AvatarFallback className='text-3xl'>{data.displayName.split('')[0]}</AvatarFallback>
                </Avatar>
            </div>

            <div className='flex flex-col gap-2'>
                <span className='capitalize font-normal'><strong>{data.funcao}</strong> {data.displayName} ({data.ra}) {data.lattes && (
                    <>
                        <span>|</span>
                        <a href={data.lattes} target='_blank' className='font-semibold' rel="noopener noreferrer">Lattes</a>
                        {data.orcid && (
                            <>
                                <span>|</span>
                                <a href={data.orcid} target='_blank' className='font-semibold' rel="noopener noreferrer">OrCid</a>
                            </>
                        )}
                    </>
                )}</span>

                <div className='flex gap-1 flex-col md:flex-row md:items-center md:gap-3'>
                    <div className='flex items-center gap-1'>
                        <FaSquarePhone color='#004882' />
                        <span>{data.telefone}</span>
                    </div>

                    <div className='flex items-center gap-1'>
                        <MdEmail color='#004882' />
                        <span>{splitEmail(data.email)}</span>
                    </div>
                </div>

                <div>
                    <i className='font-semibold'>ÁREA DE ATUAÇÃO:</i>
                    {data.areaAtuacao.map((area, index) => (
                        <p key={index}>{area}{index !== data.areaAtuacao.length - 1 ? ',' : ''}</p>
                    ))}
                </div>

                <div>
                    <i className='font-semibold'>LINHAS DE PESQUISA:</i>
                    {data.linhasPesquisa.map((area, index) => (
                        <p key={index}>{area}{index !== data.linhasPesquisa.length - 1 ? ',' : ''}</p>
                    ))}
                </div>

                {data.meusite && (    
                <div>
                    <a href={data.meusite} target='_blank' className='font-semibold' rel="noopener noreferrer">Meu site</a>
                </div>
                )}

            </div>
        </div>
    )
}

export { DocenteItem };